// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { greetingName, pickGreeting } from "@/features/home/greeting";
import { useAuth } from "@/lib/auth/auth-provider";
import { formatDateProse } from "@/lib/format";

/** A time-of-day greeting by first name, over today's date. Picked once per visit, not per render. */
export function HomeGreeting() {
  const { t, i18n } = useTranslation("back-office");
  const { user } = useAuth();
  const now = useMemo(() => new Date(), []);
  const key = useMemo(() => pickGreeting(now), [now]);

  return (
    <div className="space-y-1">
      <h2 className="text-2xl font-semibold tracking-tight">
        {t(`home.greeting.${key}`, { name: greetingName(user?.fullName, user?.email) })}
      </h2>
      <p className="text-sm text-muted-foreground">{t("home.today", { date: formatDateProse(now, i18n.language) })}</p>
    </div>
  );
}
